import type { AvatarIcons } from '@ksyos/design-system';
import type { Gender } from '../enums/gender';

export function getPatientAvatarIcon(gender: Gender | null | undefined): AvatarIcons {
    switch (gender) {
        case 'male':
            return 'patient-man';
        case 'female':
            return 'patient-woman';
        case 'other':
            return 'patient-nogender';
        case 'unknown':
            return 'patient-nogender';
        default:
            return 'patient-nogender';
    }
}
